var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-view" }, [
    _c("div", { staticClass: "main-content copyMonthSetting" }, [
      _c(
        "div",
        { staticClass: "section form-column" },
        [
          _c(
            "el-form",
            { staticStyle: { "flex-direction": "row" } },
            [
              _c(
                "el-form-item",
                { staticStyle: { "margin-bottom": "15px!important" } },
                [
                  !_vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.editHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.refreshHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticStyle: { "flex-direction": "row" },
              attrs: { "label-width": "150px", "label-position": "center" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "margin-left": "20px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("PillReport.MonthlyDataArchive")))]
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { label: _vm.$t("PillReport.MonthlyFinance") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { no: "monthlyFinance", disabled: true },
                      model: {
                        value: _vm.setting.monthlyFinance,
                        callback: function($$v) {
                          _vm.$set(_vm.setting, "monthlyFinance", $$v)
                        },
                        expression: "setting.monthlyFinance"
                      }
                    },
                    _vm._l(_vm.monthlyFinanceList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.name
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("PillReport.MonthlyHr") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { no: "monthlyHr", disabled: !_vm.isEdit },
                      model: {
                        value: _vm.setting.monthlyHr,
                        callback: function($$v) {
                          _vm.$set(_vm.setting, "monthlyHr", $$v)
                        },
                        expression: "setting.monthlyHr"
                      }
                    },
                    _vm._l(_vm.monthlyHrList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "14px",
                    "margin-left": "20px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("PillReport.MonthDataArchive")))]
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { label: _vm.$t("PillReport.WeeklyDay") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { no: "weeklyDay", disabled: !_vm.isEdit },
                      model: {
                        value: _vm.setting.weeklyDay,
                        callback: function($$v) {
                          _vm.$set(_vm.setting, "weeklyDay", $$v)
                        },
                        expression: "setting.weeklyDay"
                      }
                    },
                    _vm._l(_vm.weeklyDayList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.name
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }